import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import { initRem } from "./utils/rem.js";
import 'vant/lib/index.css'
import Vconsole from 'vconsole'
import VueLazyload from 'vue-lazyload'
import './assets/font/font.css'

if(location.href.indexOf('debugg')!=-1){
    let vConsole = new Vconsole()
    Vue.use(vConsole);
}

import { CountDown, Calendar, Loading, Toast, Popup, Picker, Area, Checkbox,Search,IndexBar, IndexAnchor, Cell, Image, Step, Steps, TreeSelect  } from "vant";
Vue.use(CountDown);
Vue.use(Calendar);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Area);
Vue.use(Checkbox);
Vue.use(ElementUI);
Vue.use(Search);
Vue.use(IndexBar).use(IndexAnchor);
Vue.use(Cell);
Vue.use(Image);
Vue.use(Step).use(Steps);
Vue.use(TreeSelect);
Vue.use(VueLazyload, {
    // 加载失败后加载的图片
    // 懒加载默认加载图片
    loading: require('./assets/images/springFestival/专题页_01.png'),
    error: 'xxx.png',
    preLoad: 1.3, // 预加载高度的比例
    attempt: 3 // 尝试加载次数
})


Vue.config.productionTip = false

initRem(750, 100);

let time = new Date().getTime()
// 中升甄品icon图
Vue.prototype.$globalVar = `https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/zsGj/img/zszhenpin.png?${time}`

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')